import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UTruncateText } from './u-truncate-text.component';
import { UiInfraModule } from "../../ui-infra.module";
@NgModule({
  declarations: [UTruncateText],
  imports: [CommonModule, UiInfraModule],
  exports: [UTruncateText],
})
export class UTruncateTextModule {}
